<script>
import swal from 'sweetalert2';

export default {
    methods: {
        deletePoint(point) {
            swal({
                title: 'Are you sure?',
                text: "You won't be able to undo this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#dd3333',
                confirmButtonText: 'Yes, delete it!',
            })
                .then(reason => {
                    // Dismissed/closed
                    if (reason.hasOwnProperty('dismiss')) {
                        return;
                    }

                    this.$axios
                        .delete(
                            route('admin.points.delete', {
                                point: point,
                            }),
                        )
                        .then(response => {
                            if (!response.data.status) {
                                swal({
                                    title: 'Error',
                                    text: response.data.error,
                                    type: 'error',
                                }).catch(swal.noop);
                            } else {
                                window.location.reload();
                            }
                        });
                })
                .catch(swal.noop);
        },
    },
};
</script>
